<div class="my-container">
  <ng-template #customLoadingTemplate></ng-template>
  <ngx-loading [show]="loading" [template]="customLoadingTemplate"></ngx-loading>
</div>
